// extracted by mini-css-extract-plugin
export default {"container":"PaymentDetails_container__xORhn","content":"PaymentDetails_content__FxG93","realContent":"PaymentDetails_realContent__N0uxm"};